import script from "./print-photo.vue?vue&type=script&setup=true&lang=js"
export * from "./print-photo.vue?vue&type=script&setup=true&lang=js"

import "./print-photo.vue?vue&type=style&index=0&id=868cc7c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-868cc7c6"]])

export default __exports__